import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { NonMovementDescriptionsComponent } from './manage-non-movement-descriptions/non-movement-descriptions.component';
import { CreateNonMovementTransactionsComponent } from './create-non-movement-transactions/create-non-movement-transactions.component';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from 'src/app/vme-common.module';
import { VMEComponentsModule } from 'src/app/vme-components.module';
import { VmeDirectivesModule } from 'src/app/vme-directives.module';
import { VmePipesModule } from 'src/app/vme-pipes.module';
import { TableModule } from 'primeng/table';
import { DataImportModule } from '../data-import/data-import.module';

const routes: Routes = [
  {
    path: '',
    component: NonMovementDescriptionsComponent,
    data: { title: 'Non-Movement Descriptions' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NonMovementDescriptionsRoutingModule {}

@NgModule({
  imports: [
    NonMovementDescriptionsRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    TableModule,
    DataImportModule,
  ],
  declarations: [NonMovementDescriptionsComponent, CreateNonMovementTransactionsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [CreateNonMovementTransactionsComponent],
})
export class NonMovementModule {}
